module.exports = __webpack_public_path__ + "img/ventureburn.70331185.jpg";